// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AdminHeader_header__N3E49 a {\n  font-size: 20px;\n  text-transform: uppercase;\n}\n.AdminHeader_header__N3E49 a:active {\n  background-color: #bb6d6d;\n}", "",{"version":3,"sources":["webpack://./src/components/Admin-panel/Header/AdminHeader.module.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,yBAAA;AAAJ;AACI;EACE,yBAAA;AACN","sourcesContent":[".header{\n  a{\n    font-size: 20px;\n    text-transform: uppercase;\n    &:active{\n      background-color: #bb6d6d;\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "AdminHeader_header__N3E49"
};
export default ___CSS_LOADER_EXPORT___;
